module.exports = __webpack_public_path__ + "static/media/0222_IMG_LE_SOL_LEGNI_WALNUT.9b2388a7.webp";